jQuery(function($) { // jQuery init

	$('.nav-drawer').click(function() {
		var $this = $(this);

		$this.toggleClass('active');
		$('#site-navigation').toggleClass('toggled');

	});

	// $('#menu-main-menu > .menu-item > a').dblclick(function(e) {
	// 	e.preventDefault();
	// 	alert('double click');
	// }).click(function(e) {
	// 	e.preventDefault();
	// });
	
});
